
import React from 'react';
const PencilIcon = (props: React.SVGProps<SVGSVGElement>) =>
(
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <g clipPath="url(#clip0_7808_9747)">
            <path d="M11.333 1.99955C11.5081 1.82445 11.716 1.68556 11.9447 1.5908C12.1735 1.49604 12.4187 1.44727 12.6663 1.44727C12.914 1.44727 13.1592 1.49604 13.3879 1.5908C13.6167 1.68556 13.8246 1.82445 13.9997 1.99955C14.1748 2.17465 14.3137 2.38252 14.4084 2.61129C14.5032 2.84006 14.552 3.08526 14.552 3.33288C14.552 3.58051 14.5032 3.8257 14.4084 4.05448C14.3137 4.28325 14.1748 4.49112 13.9997 4.66622L4.99967 13.6662L1.33301 14.6662L2.33301 10.9996L11.333 1.99955Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_7808_9747">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>



);


export default PencilIcon;
